module.exports = __webpack_public_path__ + "assets/4ace3b1fb305e9f22ea7ce0564f08b36.png";